import { defineMessages } from 'react-intl'

export default defineMessages({
  experienceLabel: {
    id: 'containers.CustomerFeedbackPage.experienceLabel',
    defaultMessage: 'How was your overall experience, with your latest VoiceArchive project?',
  },
  experiencePlaceholder: {
    id: 'containers.CustomerFeedbackPage.experiencePlaceholder',
    defaultMessage: 'How was your overall experience, with your latest VoiceArchive project?',
  },
  productionLabel: {
    id: 'containers.CustomerFeedbackPage.productionLabel',
    defaultMessage: 'How was you experience with me, as your project manager?',
  },
  productionPlaceholder: {
    id: 'containers.CustomerFeedbackPage.productionPlaceholder',
    defaultMessage: 'How was you experience with me, as your project manager?',
  },
  npsLabel: {
    id: 'containers.CustomerFeedbackPage.npsLabel',
    defaultMessage: 'How likely are you to recommend VoiceArchive to a colleague?',
  },
  npsPlaceholder: {
    id: 'containers.CustomerFeedbackPage.npsPlaceholder',
    defaultMessage: 'How likely are you to recommend VoiceArchive to a colleague?',
  },
  salesLabel: {
    id: 'containers.CustomerFeedbackPage.salesLabel',
    defaultMessage: 'How did I do, helping you get started with your project?',
  },
  salesPlaceholder: {
    id: 'containers.CustomerFeedbackPage.salesPlaceholder',
    defaultMessage: 'How did I do, helping you get started with your project?',
  },
  postProductionLabel: {
    id: 'containers.CustomerFeedbackPage.postProductionLabel',
    defaultMessage: 'How was my post production recording?',
  },
  postProductionPlaceholder: {
    id: 'containers.CustomerFeedbackPage.postProductionPlaceholder',
    defaultMessage: 'How was my post production recording?',
  },
  taskLabel: {
    id: 'containers.CustomerFeedbackPage.taskLabel',
    defaultMessage: 'How was my recording?',
  },
  taskPlaceholder: {
    id: 'containers.CustomerFeedbackPage.taskPlaceholder',
    defaultMessage: 'How was my recording?',
  },
  feedbackPartiallySubmitted: {
    id: 'containers.CustomerFeedbackPage.feedbackPartiallySubmitted',
    defaultMessage: 'Thank you for your feedback. Please come back at any time to fill out the rest.',
  },
  feedbackFullySubmitted: {
    id: 'containers.CustomerFeedbackPage.feedbackFullySubmitted',
    defaultMessage: 'Thank you for your feedback. Looking forward to your next project.',
  }
})
